import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ReviewersFilterDialogData {
  startDate?: Date;
  endDate?: Date;
  status?: string;
  myDocuments?: boolean;
}

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './reviewers-filter-dialog.component.html',
  styleUrls: ['./reviewers-filter-dialog.component.scss']
})
export class ReviewersFilterDialogComponent {
  filterForm: FormGroup;
  statuses = ['ALL', 'DONE', 'IN-PROGRESS'];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ReviewersFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReviewersFilterDialogData
  ) {
    this.filterForm = this.fb.group({
      startDate: [data.startDate || null],
      endDate: [data.endDate || null],
      status: [data.status || 'ALL'],
      myDocuments: [data.myDocuments || false]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onClear(): void {
    this.filterForm.reset({
      startDate: null,
      endDate: null,
      status: 'ALL',
      myDocuments: false
    });
  }

  onApply(): void {
    this.dialogRef.close(this.filterForm.value);
  }
}
